

export default function getProducts(room, austattung_produkt){

    const productList = [];
    const cProducts = [];

    if(
        room.selectedEquipment["telefon_datenanschluss"] !== undefined
        && room.selectedEquipment["telefon_datenanschluss"] > 0
        && austattung_produkt["uae"] !== undefined
        && austattung_produkt["uae-zentralstueck"] !== undefined
    ){
        productList.push({
            product: austattung_produkt["uae"],
            count: room.selectedEquipment["telefon_datenanschluss"]
        });
        productList.push({
            product: austattung_produkt["uae-zentralstueck"],
            count: room.selectedEquipment["telefon_datenanschluss"]
        });
        for(let k = 0; k < room.selectedEquipment['telefon_datenanschluss']; k++) {
            cProducts.push([austattung_produkt["uae"], austattung_produkt["uae-zentralstueck"]]);
        }
    }

    return { productList: productList, cProducts: cProducts };
}
